// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, type SerializedStyles } from '@emotion/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const expandIconWrapperStyle: SerializedStyles = css({
	marginLeft: token('space.negative.100'),
});

/**
 * @private
 * @deprecated use `import { ToolbarExpandIcon } from '@atlaskit/editor-common/ui';` instead
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const expandIconContainerStyle: SerializedStyles = css({
	display: 'flex',
	alignItems: 'center',
});

const prefix = 'ak-editor-expand';

export const expandClassNames: {
	prefix: string;
	expanded: string;
	titleContainer: string;
	inputContainer: string;
	iconContainer: string;
	icon: string;
	iconButton: string;
	iconSvg: string;
	titleInput: string;
	content: string;
	contentCollapsed: string;
	type: (type: string) => string;
} = {
	prefix,
	expanded: `${prefix}__expanded`,
	titleContainer: `${prefix}__title-container`,
	inputContainer: `${prefix}__input-container`,
	iconContainer: `${prefix}__icon-container`,
	icon: `${prefix}__icon`,
	iconButton: `${prefix}__icon-button`,
	iconSvg: `${prefix}__icon-svg`,
	titleInput: `${prefix}__title-input`,
	content: `${prefix}__content`,
	contentCollapsed: `${prefix}__content--collapsed`,
	type: (type: string) => `${prefix}__type-${type}`,
};
